import { ModalHelper } from '../../components/modal/modal.helper';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var RedirectComponent = (function () {
    function RedirectComponent(_modal, _utils, _blogic, _data) {
        this._modal = _modal;
        this._utils = _utils;
        this._blogic = _blogic;
        this._data = _data;
        this.withoutTurn = false;
        this.redirectForm = {};
        this.cclient = "";
        this.nameClient = "";
        this.queues = [];
        this.atypes = [];
        this.atypesAll = [];
        this.error = false;
        this.actualFormType = "queue";
        this.destroy$ = new Subject();
    }
    RedirectComponent.prototype.ngOnInit = function () {
        if (this._data.configuration['useOnlyDeskRedirection']) {
            this.actualFormType = "desk";
        }
        else {
            this.actualFormType = "queue";
        }
    };
    RedirectComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    /* Open redirect modal */
    RedirectComponent.prototype.openRedirectModal = function () {
        if (this._data.selectedTurn == null) {
            this.cclient = this._data.turn["clientid"];
            this.nameClient = this._data.turn["clientname"];
            this.redirectForm['comment'] = this._utils.convertToPlainText(this._data.turn["rdcomment"]);
        }
        else {
            this.cclient = this._data.selectedTurn["clientid"];
            this.nameClient = this._data.selectedTurn["clientname"];
            this.redirectForm['comment'] = this._utils.convertToPlainText(this._data.selectedTurn["rdcomment"]);
        }
        this._blogic.getOnlineList();
        this._getQueueList();
    };
    /* Redirect action */
    RedirectComponent.prototype.redirect = function () {
        var params;
        if (this._data.configuration["activeSupervisor"]
            && this._data.selectedTurn != null) {
            if (!this.withoutTurn) {
                params = {
                    desk_id: this._data.selectedTurn["desk"],
                    turn_id: this._data.selectedTurn["id"],
                    fromqueue: this._data.selectedTurn["queue_id"],
                    toqueue: parseInt(this.redirectForm["queue"]),
                    rdcomment: this.redirectForm["comment"],
                    position: this.redirectForm["mode"],
                    kind_id: this.redirectForm["atype"],
                    deskuser: this._data.session["username"],
                    deskoperator: this._data.session["operator"]
                };
            }
            else {
                params = {
                    desk_id: null,
                    turn_id: this._data.selectedTurn["id"],
                    fromqueue: this._data.selectedTurn["queue_id"],
                    toqueue: parseInt(this.redirectForm["queue"]),
                    rdcomment: this.redirectForm["comment"],
                    position: this.redirectForm["mode"],
                    kind_id: this.redirectForm["atype"],
                    deskuser: this._data.session["username"],
                    deskoperator: this._data.session["operator"]
                };
            }
        }
        else {
            params = {
                desk_id: this._data.session["desk"],
                turn_id: this._data.turn["id"],
                fromqueue: this._data.turn["queue_id"],
                toqueue: this.redirectForm["queue"],
                rdcomment: this.redirectForm["comment"],
                position: this.redirectForm["mode"],
                kind_id: this.redirectForm["atype"],
                deskuser: this._data.session["username"],
                deskoperator: this._data.session["operator"]
            };
        }
        this._changeInfo(params);
    };
    RedirectComponent.prototype._doMove = function (params) {
        var _this = this;
        if (!this._data.configuration["redirectFirstAndLastMode"])
            params["position"] = "S";
        this._blogic.moveTurn(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.actionContainer = 0;
            _this._modal.hide("redirectModal");
            _this._data.turn = null;
            _this._data.selectedTurn = null;
        });
    };
    RedirectComponent.prototype._changeInfo = function (moveParams) {
        var _this = this;
        var params;
        if (this._data.configuration["activeSupervisor"]
            && this._data.selectedTurn != null) {
            if (!this.withoutTurn) {
                params = {
                    desk_id: this._data.session["desk"],
                    turn_id: this._data.selectedTurn["id"],
                    queue_id: this._data.selectedTurn["queue_id"],
                    prekind: this._data.selectedTurn["prekind_id"],
                    task: this._data.selectedTurn["task"],
                    clientid: this.cclient,
                    clientname: this.nameClient,
                    /*planhour: this._data.selectedTurn["planhour"],*/
                    plandate: this._data.selectedTurn["plandate"]
                };
            }
            else {
                params = {
                    desk_id: null,
                    turn_id: this._data.selectedTurn["id"],
                    queue_id: this._data.selectedTurn["queue_id"],
                    prekind: this._data.selectedTurn["prekind_id"],
                    task: this._data.selectedTurn["task"],
                    clientid: this.cclient,
                    clientname: this.nameClient,
                    /*planhour: this._data.selectedTurn["planhour"],*/
                    plandate: this._data.selectedTurn["plandate"]
                };
            }
        }
        else {
            params = {
                desk_id: this._data.session["desk"],
                turn_id: this._data.turn["id"],
                queue_id: this._data.turn["queue_id"],
                prekind: this._data.turn["prekind_id"],
                task: this._data.turn["task"],
                clientid: this.cclient,
                clientname: this.nameClient,
                /*planhour: this._data.turn["planhour"]*/
                plandate: this._data.turn["plandate"]
            };
        }
        this._blogic.setTicketInfo(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._doMove(moveParams);
        });
    };
    /* Parse queue list using the desk id as key of array */
    RedirectComponent.prototype._parseQueues = function (queues) {
        var parseArray = queues;
        var filterArray = [];
        if (this._data.session["redirectorder"].length != 0) {
            var availableQueues = this._data.session["redirectorder"].split(',');
            for (var i = 0; i < parseArray.length; i++) {
                var index = availableQueues.indexOf(parseArray[i].id.toString());
                if (index != -1 || parseArray[i].qdesk_id != null) {
                    filterArray[i] = parseArray[i];
                }
            }
            this.queues = this.cleanArray(filterArray);
        }
        else {
            this.queues = parseArray;
        }
        //this.atypesAll = this._parseAtypes();
        if (this.queues.length == 1) {
            this.redirectForm["queue"] = this.queues[0].id;
            this.changeQueue();
        }
        //this.changeQueue();
        if (this.atypes.length == 1) {
            this.redirectForm["atype"] = this.atypes[0].id;
        }
        this.redirectForm["mode"] = "S";
        this._modal.show("redirectModal");
    };
    /* Clean a Array deleting the empty slots */
    RedirectComponent.prototype.cleanArray = function (actual) {
        var newArray = new Array();
        for (var i = 0; i < actual.length; i++) {
            if (actual[i]) {
                newArray.push(actual[i]);
            }
        }
        return newArray;
    };
    RedirectComponent.prototype.getActualQueues = function () {
        var queues = [];
        if (this.actualFormType == 'queue') {
            this.queues.forEach(function (e) {
                if (e.qdesk_id == null)
                    queues.push(e);
            });
        }
        if (this.actualFormType == 'desk') {
            this.queues.forEach(function (e) {
                if (e["qdeskactive"])
                    queues.push(e);
            });
            queues = queues.sort(function (a, b) {
                return a.qdesk_id - b.qdesk_id;
            });
        }
        return queues;
    };
    /* Get queue list */
    RedirectComponent.prototype._getQueueList = function () {
        var _this = this;
        var params = {
            filter: "queue?ignorehidden=true"
        };
        this._blogic.getPlanList(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var queues = response;
            _this._parseQueues(queues);
        });
    };
    RedirectComponent.prototype.changeQueue = function () {
        var _this = this;
        var queue = this.queues.find(function (x) { return x.id.toString() === _this.redirectForm['queue'].toString(); });
        var queueAtypes = queue.qkinds;
        this.redirectForm['qdesk_id'] = queue.qdesk_id;
        this._blogic.kindListOffice()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var parseArray = response;
            var filterArray = [];
            var atypes = [];
            if (_this._data.session["redirectkind"].length != 0) {
                var availableAtypes = _this._data.session["redirectkind"].split(',');
                for (var i = 0; i < parseArray.length; i++) {
                    var index = availableAtypes.indexOf(parseArray[i].id.toString());
                    if (index != -1) {
                        filterArray[index] = parseArray[i];
                    }
                }
                atypes = _this.cleanArray(filterArray);
            }
            _this.atypes = atypes.filter(function (e) { return queueAtypes.indexOf(e.id) !== -1; });
            if (_this.atypes.length == 1) {
                _this.redirectForm['atype'] = _this.atypes[0].id;
            }
        });
    };
    return RedirectComponent;
}());
export { RedirectComponent };
